import convertPgStyleParamsToWixStyleParams from './convertPgStyleParamsToWixStyleParams/convertPgStyleParamsToWixStyleParams';
var getParsedTouchUpUndoStateParam = function (isTouchUpClick) {
    // Add touchUp - Undo cycle state style param
    return [
        {
            type: 'boolean',
            key: 'isTouchUpEnabled',
            value: {
                value: !isTouchUpClick,
            },
        },
    ];
};
var getParsedUndoSavingObj = function (galleryPrevSPs) {
    // Add touchUp - Undo cycle state style param
    return [
        {
            type: 'font',
            key: 'galleryPrevSPs',
            value: {
                value: galleryPrevSPs,
            },
        },
    ];
};
var getTypeAndValueFromWixStyles = function (overwritingSPs, wixStyles, param, prefix, defaultValue) {
    return {
        key: prefix + param,
        type: wixStyles[param]['type'],
        value: {
            value: overwritingSPs[prefix + param] || defaultValue,
        },
    };
};
/** Helper functions */
var textBoxWidthGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var calculateTextBoxWidthMode = overwritingStyles.calculateTextBoxWidthMode;
    var textBoxWidthType = calculateTextBoxWidthMode === 'PERCENT'
        ? 'textBoxWidthPercent'
        : 'textBoxWidth';
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'calculateTextBoxWidthMode', stylePrefix, defaultWixStyles['calculateTextBoxWidthMode']),
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, textBoxWidthType, stylePrefix, defaultWixStyles[textBoxWidthType]),
    ];
};
var textBoxHeightGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var calculateTextBoxHeightMode = overwritingStyles.calculateTextBoxHeightMode;
    var setParams = [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'calculateTextBoxHeightMode', stylePrefix, defaultWixStyles['calculateTextBoxHeightMode']),
    ];
    if (calculateTextBoxHeightMode === 'MANUAL') {
        setParams.push(getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'textBoxHeight', stylePrefix, defaultWixStyles['textBoxHeight']));
    }
    return setParams;
};
var textsVerticalPaddingGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'textsVerticalPadding', stylePrefix, defaultWixStyles['textsVerticalPadding']),
    ];
};
var navigationArrowsGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'arrowsPadding', stylePrefix, defaultWixStyles['arrowsPadding']),
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'arrowsSize', stylePrefix, defaultWixStyles['arrowsSize']),
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'arrowsVerticalPosition', stylePrefix, defaultWixStyles['arrowsVerticalPosition']),
    ];
};
var textHorizontalAlignmentGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'galleryHorizontalAlign', stylePrefix, defaultWixStyles['galleryHorizontalAlign']),
    ];
};
var titleDescriptionSpaceGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'titleDescriptionSpace', stylePrefix, defaultWixStyles['titleDescriptionSpace']),
    ];
};
var textsHorizontalPaddingGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'textsHorizontalPadding', stylePrefix, defaultWixStyles['textsHorizontalPadding']),
    ];
};
// Check default case
var itemFontSlideshowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemFontSlideshow = overwritingStyles.itemFontSlideshow;
    // Added layer of protection in case the default case in convertPgStyleParamsToWix... will be removed
    if (!itemFontSlideshow)
        return;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemFontSlideshow', stylePrefix),
    ];
};
var itemFontGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemFont = overwritingStyles.itemFont;
    if (!itemFont)
        return;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemFont', stylePrefix),
    ];
};
var itemDescriptionFontSlideshowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemDescriptionFontSlideshow = overwritingStyles.itemDescriptionFontSlideshow;
    if (!itemDescriptionFontSlideshow)
        return;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemDescriptionFontSlideshow', stylePrefix),
    ];
};
var itemDescriptionFontGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemDescriptionFont = overwritingStyles.itemDescriptionFont;
    if (!itemDescriptionFont)
        return;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemDescriptionFont', stylePrefix),
    ];
};
var slideshowInfoSizeGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'slideshowInfoSize', stylePrefix, defaultWixStyles['slideshowInfoSize']),
    ];
};
var textImageSpaceGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var textImageSpace = overwritingStyles.textImageSpace;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'textImageSpace', stylePrefix, defaultWixStyles['textImageSpace']),
    ];
};
var itemBorderRadiusGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemBorderRadius = overwritingStyles.itemBorderRadius;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemBorderRadius', stylePrefix, defaultWixStyles['itemBorderRadius']),
    ];
};
var isVerticalGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var isVertical = overwritingStyles.isVertical;
    // Unless explicitly stated, not changing user's isVertical
    if (!isVertical)
        return;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'isVertical', stylePrefix),
    ];
};
var galleryVerticalAlignGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'galleryVerticalAlign', stylePrefix, defaultWixStyles['galleryVerticalAlign']),
    ];
};
var collageDensityGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var collageDensity = overwritingStyles.collageDensity;
    if (!collageDensity)
        return;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'collageDensity', stylePrefix),
    ];
};
var imageMarginGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var imageMargin = overwritingStyles.imageMargin;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'imageMargin', stylePrefix, defaultWixStyles['imageMargin']),
    ];
};
var itemBorderWidthGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemBorderWidth = overwritingStyles.itemBorderWidth;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemBorderWidth', stylePrefix, defaultWixStyles['itemBorderWidth']),
    ];
};
var itemShadowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemEnableShadow = overwritingStyles.itemEnableShadow;
    // SPs to set
    var setParams = [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemEnableShadow', stylePrefix, defaultWixStyles['itemEnableShadow']),
    ];
    var shadowParamsIfEnabled = [];
    if (itemEnableShadow === true) {
        shadowParamsIfEnabled = [
            getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemShadowBlur', stylePrefix, defaultWixStyles['itemShadowBlur']),
            getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemShadowDirection', stylePrefix, defaultWixStyles['itemShadowDirection']),
            getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'itemShadowSize', stylePrefix, defaultWixStyles['itemShadowSize']),
        ];
    }
    return setParams.concat(shadowParamsIfEnabled);
};
var hoveringBehaviourGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'hoveringBehaviour', stylePrefix, defaultWixStyles['hoveringBehaviour']),
    ];
};
// here
var scrollAnimationGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'scrollAnimation', stylePrefix, defaultWixStyles['scrollAnimation']),
    ];
};
var imageHoverAnimationGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'imageHoverAnimation', stylePrefix, defaultWixStyles['imageHoverAnimation']),
    ];
};
var overlaySizeGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var overlaySizeType = overwritingStyles.overlaySizeType;
    var overlaySizeParam = overlaySizeType === 'PIXEL' ? 'overlaySizePixel' : 'overlaySizePercent';
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'scrollAnimation', stylePrefix, defaultWixStyles['scrollAnimation']),
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'overlaySize', stylePrefix, defaultWixStyles['overlaySize']),
    ];
};
var overlayPaddingGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var overlayPadding = overwritingStyles.overlayPadding;
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'overlayPadding', stylePrefix, defaultWixStyles['overlayPadding']),
    ];
};
var overlayPositionGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'overlayPosition', stylePrefix, defaultWixStyles['overlayPosition']),
    ];
};
var overlayAnimationGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'overlayAnimation', stylePrefix, defaultWixStyles['overlayAnimation']),
    ];
};
var cubeTypeGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'imageResize', stylePrefix, defaultWixStyles['imageResize']),
    ];
};
var textBoxBorderWidthGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'textBoxBorderWidth', stylePrefix, defaultWixStyles['textBoxBorderWidth']),
    ];
};
var numberOfImagesPerColGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'numberOfImagesPerCol', stylePrefix, defaultWixStyles['numberOfImagesPerCol']),
    ];
};
var numberOfImagesPerRowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(overwritingStyles, wixStyles, 'numberOfImagesPerRow', stylePrefix, defaultWixStyles['numberOfImagesPerRow']),
    ];
};
// All style params we overwrite
var overwritingAutofixParams = {
    textBoxWidth: textBoxWidthGetter,
    textBoxHeight: textBoxHeightGetter,
    navigationArrows: navigationArrowsGetter,
    isVertical: isVerticalGetter,
    textImageSpace: textImageSpaceGetter,
    slideshowInfoSize: slideshowInfoSizeGetter,
    itemFontSlideshow: itemFontSlideshowGetter,
    itemFont: itemFontGetter,
    itemDescriptionFont: itemDescriptionFontGetter,
    itemDescriptionFontSlideshow: itemDescriptionFontSlideshowGetter,
    textsVerticalPadding: textsVerticalPaddingGetter,
    textsHorizontalPadding: textsHorizontalPaddingGetter,
    itemBorderRadius: itemBorderRadiusGetter,
    titleDescriptionSpace: titleDescriptionSpaceGetter,
    galleryTextAlign: textHorizontalAlignmentGetter,
    galleryVerticalAlign: galleryVerticalAlignGetter,
    overlaySize: overlaySizeGetter,
    overlayPadding: overlayPaddingGetter,
    overlayPosition: overlayPositionGetter,
    overlayAnimation: overlayAnimationGetter,
    cubeType: cubeTypeGetter,
    collageDensity: collageDensityGetter,
    imageMargin: imageMarginGetter,
    hoveringBehaviour: hoveringBehaviourGetter,
    scrollAnimation: scrollAnimationGetter,
    imageHoverAnimation: imageHoverAnimationGetter,
    itemBorderWidth: itemBorderWidthGetter,
    itemShadow: itemShadowGetter,
    textBoxBorderWidth: textBoxBorderWidthGetter,
    numberOfImagesPerCol: numberOfImagesPerColGetter,
    numberOfImagesPerRow: numberOfImagesPerRowGetter,
};
var getParsedTouchUpStyles = function (stylesFromServer, isMobile) {
    // Later on we can use isMobile to filter only relevant wix-styles
    return parseStylesFromServerToBeCompatibleWithStyleSetter(stylesFromServer);
};
var parseStylesFromServerToBeCompatibleWithStyleSetter = function (theStylesFromTheServer) {
    // wixStyles group of same type is in plural, the type itself is singular
    var pluralTypeToSingularType = {
        booleans: 'boolean',
        numbers: 'number',
        fonts: 'font',
        colors: 'color',
        manuals: 'manual',
    };
    var arrayOfCompatibleStylesToSet = [];
    // theStylesFromTheServer is of shape {numbers: {}, booleans: {}, etc.}
    for (var _i = 0, _a = Object.keys(theStylesFromTheServer); _i < _a.length; _i++) {
        var groupStylesType = _a[_i];
        // Singular actual type to set ('number', 'boolean', etc.)
        var typeToSet = pluralTypeToSingularType[groupStylesType];
        if (typeof typeToSet === 'undefined') {
            // for keys such as 'GoogleFontsCssUrl' which are not an object of {styleParam : value}
            continue;
        }
        // If here we want to go through the nested styles object of the same type and add to the result array
        for (var _b = 0, _c = Object.keys(theStylesFromTheServer[groupStylesType]); _b < _c.length; _b++) {
            var styleParam = _c[_b];
            arrayOfCompatibleStylesToSet.push({
                key: styleParam,
                type: typeToSet,
                value: {
                    value: theStylesFromTheServer[groupStylesType][styleParam],
                },
            });
        }
    }
    return arrayOfCompatibleStylesToSet;
};
export var touchUpUndoSetter = function (galleryToSet, isTouchUpClick, styleSetter, isMobile) {
    var parsedStylesToSet = [];
    parsedStylesToSet.push.apply(parsedStylesToSet, getParsedTouchUpStyles(galleryToSet, isMobile));
    parsedStylesToSet.push.apply(parsedStylesToSet, getParsedTouchUpUndoStateParam(isTouchUpClick));
    styleSetter(parsedStylesToSet);
};
//# sourceMappingURL=touchUpUtils.js.map